import * as Sentry from '@sentry/react';
import { useFirebase } from 'containers/FirebaseContext';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateUI } from 'store/UI/actions';
import { useUI } from 'store/UI/selectors';
import { COTATION } from 'utils/config/reference';
import { useQuotes } from 'utils/methods/quotes';

const useQuotesData = () => {
  const { quotesData = [] } = useUI();
  const { listenQuotes } = useQuotes();
  const { firebaseUser } = useFirebase();
  const dispatch = useDispatch();
  const id = `quotes-${import.meta.env.VITE_APP_STAGE?.trim() === 'prod' ? 'prod' : 'dev'}`;

  useEffect(() => {
    try {
      if (!firebaseUser || !(firebaseUser && firebaseUser.uid)) {
        dispatch(updateUI({ quotesData: COTATION }));
        return; 
      }
      const unsubscribe = listenQuotes(id, (data) => {
        if (data?.[id]?.data) {
          const parsedData = JSON.parse(data[id].data);
          const sortedData = parsedData.sort((a, b) => {
            const dateA = new Date(a.updated_at || a.created_at || 0);
            const dateB = new Date(b.updated_at || a.created_at || 0);
            return dateB - dateA;
          });
          dispatch(updateUI({ quotesData: sortedData || COTATION }));
        } else {
          dispatch(updateUI({ quotesData: COTATION }));
        }
      });
      return () => unsubscribe();
    } catch (error) {
      Sentry.captureException(`659 Error listening to session changes: ${error}`);
    }
  }, [firebaseUser]);

  return {
    quotesData: quotesData || [],
  };
};

export default useQuotesData;
